import React, { useEffect, useState } from 'react';
import { List, Empty, Tag, Button, Modal } from 'antd';

import { createUseStyles } from 'react-jss'

import Icofont from 'react-icofont';

import uuid from 'react-uuid';
import { errorCatch, GET, If, JSXMap, useAuth } from 'fennec-ui';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useSelector } from 'react-redux';
import Nl2Br from '../../../common/Nl2br';
dayjs.locale('ru');

var _ = require('lodash');

const useStyles = createUseStyles({
    selectPeople: {
        paddingBottom: "5px",
        '& .ant-input-prefix': {
            marginRight: "11px"
        },
        '& .ant-input-affix-wrapper': {
            padding: "4px 0px"
        }
    },
    listMeta: {
        '& .ant-list-item-meta-title': {
            marginBottom: "0"
        },
    },
    itemsListUsluga: {
        '& .ant-list .ant-list-item': {
            borderBottom: "1px solid #e1e1e1",
            alignItems: "flex-start"
        },
    },
    itemsOrderUsluga: {
        '& .ant-list-item': {
            alignItems: "flex-start"
        },
    },
    promo: {
        '& .ant-input-affix-wrapper': {
            paddingLeft: "0px",
        },
        '&': {
            borderBottom: "1px solid darkblue",
        },
        '&:hover': {
            borderBottom: "2px solid darkblue",
        },
    },
    appendButton: {
        '&.ant-btn': {
            width: "100%",
            backgroundColor: "#d9d9d9",
            boxShadow: "0px 1px 3px 0px rgba(141,141,141,0.74)",
            fontWeight: 600
        },
        '&.ant-btn:hover': {
            color: "#000",
            // background: #fff;
            boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
            borderColor: "#d9d9d9",
        },
        '&.ant-btn:focus': {
            color: "#000",
            // background: #fff;
            boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
            borderColor: "#d9d9d9",
        }
    }
})

const Header = ({ icon, title, style }) => {
    return (<span>
        <Icofont icon={icon} style={style} />
        <span>{title}</span>
    </span>);
};
const SingleHeader = () => {
    return (<Header icon="user-alt-3" title="Одиночный" style={{ color: "cadetblue", fontSize: "13px", paddingRight: "6px" }} />);
};
const FemaleHeader = () => {
    return (<Header icon="businesswoman" title="Женский" style={{ color: "red", fontSize: "16px", paddingRight: "6px" }} />);
};
const MaleHeader = () => {
    return (<Header icon="businessman" title="Мужской" style={{ color: "blue", fontSize: "16px", paddingRight: "6px" }} />);
};
const SelectCategory = (props) => {
    const { value } = props;
    if (!value || !value.kategoriya) {
        return (<></>);
    }
    return (<span>
        <span> - </span>
        <span style={{ fontStyle: "italic" }}>
            <a href="#">{_.get(value, "kategoriya.kategoriya.tantsevalnayaDistsiplina.nazvanie")} / {_.get(value, "kategoriya.kategoriya.kategoriyaUchastnikov.nazvanie")}</a>
        </span>
    </span>);
};
const SelectPeople = (props) => {
    const classes = useStyles();
    const { data, prefix, value } = props;
    const display = (object) => {
        if (object === undefined) {
            return <span>Укажите участника!</span>;
        }
        if (object) {
            if (object.polzovatelStrokoi) {
                return <span>{object.polzovatelStrokoi}</span>;
            }
            if (object.polzovatel) {
                return <span>{object.polzovatel.firstname + " " + object.polzovatel.lastname}</span>;
            }
            return <span>Укажите участника!</span>;
        }
        return <></>;
    };
    const triggerFunc = React.useMemo(() => (click) => (<Tag color={(value === undefined) ? "red" : ""} onClick={click}>
        {display(value)}
    </Tag>), [value]);
    // const filteredValue = (value && value.okazannieUslugiPolzovatelyamUchastik) ? value.okazannieUslugiPolzovatelyamUchastik.filter(i => i.uslugaKlientu.yacheikaUsluga.prilozhenieID) : undefined;
    return (<div className={classes.selectPeople}>
        <div>
            {prefix}
            <span style={{ paddingLeft: "10px" }}>{triggerFunc(() => { })}</span>
        </div>
        {!!value && <Services data={data} value={value.okazannieUslugiPolzovatelyamUchastik} />}
    </div>);
};
const SelectPartner = (props) => {
    const auth = useAuth()
    const { item, value, onChange, data } = props;
    const user = useSelector(state => state.home.user);

    const display = (object) => {
        if (!object) {
            return <span>Укажите {(value?.tipTDID === 1) ? "ассистента" : "партнера"}!</span>;
        }
        if (object) {
            return <span>{object.firstname + " " + object.lastname}</span>;
        }
        return <></>;
    };

    return (<div style={{ display: "flex", gap: "5px" }}>
        <div style={{ fontStyle: "italic" }}> - {(value?.tipTDID === 1) ? "ассистент" : "партнер"} - </div>
        <div>
            {display(value?.partner)}
        </div>
    </div>);
};
const Services = (props) => {
    const { auth, data, value } = props;
    const find = (data, i) => {
        let o = (data) ? data.find(e => e.ID === i.uslugaKlientuID) : undefined;;
        return o;
    };
    return (<div style={{ paddingTop: "3px", fontSize: "13px" }}>
        {(!!value) && JSXMap(value, (i, idx) => <div key={idx}>
            <div>
                <span>- {i.uslugaKlientu.yacheikaUsluga.nazvanie}</span>
                <SelectCategory auth={auth} value={i} />
                {(i?.tipTDID === 1 || i?.tipTDID === 2) && <div>
                    <SelectPartner
                        auth={auth}
                        item={find(data, i)}
                        value={i}
                        data={data}
                    />
                </div>}
            </div>
        </div>)}
    </div>);
};
const Male = (props) => {
    const { auth, item, index, value } = props;
    const gender = 1;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            prefix={<MaleHeader />}
            item={item}
            index={index}
            value={value} />
    </div>);
};
const Female = (props) => {
    const { auth, item, index, value } = props;
    const gender = 2;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            item={item}
            index={index}
            prefix={<FemaleHeader />}
            value={value} />
    </div>);
};
const Single = (props) => {
    const { auth, item, index, value } = props;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={<SingleHeader />}
            item={item}
            index={index}
            value={value} />
    </div>);
};
const SingleByGender = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    let genderID = value?.polzovatel?.genderID || value?.genderID;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={(genderID == 1) ? <MaleHeader /> : (genderID == 2) ? <FemaleHeader /> : <Header icon="user-alt-3" title="" style={{ color: "cadetblue", fontSize: "13px" }} />}
            item={item}
            gender={genderID}
            index={index}
            value={value} />
    </div>);
};
const RenderCartItem = (props) => {
    const classes = useStyles();
    const { auth, item, index } = props;
    const description = (<div>
        {(!!item.uslugaNaMeropriyatii && !!item.uslugaNaMeropriyatii.opisanie) && <div style={{ fontSize: "13px" }}>{item.uslugaNaMeropriyatii.opisanie}</div>}
    </div>);
    const getPeopleByGender = (array, genderID) => {
        if (!array) return;
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if ((element.polzovatel && element.polzovatel.genderID === genderID) ||
                (element.genderID && element.genderID === genderID) ||
                (element.polzovatelStrokoi)) {
                return element;
            }
        }
    };
    return (<>
        <div style={{ flex: "auto" }}>
            <List.Item.Meta
                className={classes.listMeta}
                title={item.uslugaNaMeropriyatii.nazvanie}
                description={description}
            />
            <div style={{ alignSelf: "flex-start", textAlign: "start" }}>
                <div style={{ padding: "5px 0px" }}>
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 1) &&
                        <Male auth={auth} item={item} index={index}
                            value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 1)}
                        />
                    }
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 2) &&
                        <Female auth={auth} item={item} index={index}
                            value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 2)}
                        />
                    }
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 3) &&
                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                            <div>
                                <div style={{ paddingBottom: "5px" }}>
                                    <SingleByGender auth={auth} item={item} index={index}
                                        value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")} />
                                </div>
                                <div style={{ paddingBottom: "5px" }}>
                                    <SingleByGender auth={auth} item={item} index={index}
                                        value={_.get(item, "polzovateliVZakazeTovarVZakaze[1]")} />
                                </div>
                            </div>
                        </div>}
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 4) &&
                        <Single auth={auth} item={item} index={index}
                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")}
                        />
                    }
                </div>
            </div>
            {(item?.uslugaNaMeropriyatii?.vklyuchitKommentarii == true) && <div style={{ maxWidth: "500px" }}>
                <div className='bg bg-transparent border-grey' style={{ fontSize: "12px", textAlign: "left", margin: "5px 0" }}>
                    <div style={{ fontSize: "11px", color: "rgba(0,0,0,.65)", display: "flex", justifyContent: "space-between" }}>
                        <div><i className="fa fa-comments-o"></i> Комментарий покупателя</div>
                        {/* <div><i className="fa fa-pencil-square-o"></i></div> */}
                    </div>
                    <div><Nl2Br text={item?.kommentarii} /></div>
                </div>
            </div>}
        </div>
        <div>
            <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "16px" }}>
                <div style={(item.tsena !== item.tsenaDoPromokoda) ? { textDecoration: "line-through" } : {}}>{(item.tsenaDoPromokoda).toLocaleString()} руб.</div>
                {(item.tsena !== item.tsenaDoPromokoda) && <div style={{ color: "red" }}>{(item.tsena).toLocaleString()} руб.</div>}
            </div>
        </div>
    </>)
};
function CollectionList(props) {
    const classes = useStyles();
    const { auth, zakaz, loading } = props;

    return (
        <div>
            <List
                className={classes.itemsOrderUsluga}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет абонементов" /> }}
                style={{ borderBottom: "1px solid #f0f0f0" }}
                itemLayout="horizontal"
                dataSource={(zakaz) ? zakaz.tovariVZakazeZakaz : []}
                loading={loading}
                renderItem={(item, index) => (
                    <List.Item>
                        <RenderCartItem auth={auth} uuid={uuid()} item={item} index={index} zakaz={zakaz} promo={zakaz.promokod} />
                    </List.Item>
                )}
            />
            {!loading && <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500", fontSize: "16px", padding: "10px 0px 0px 0px" }}>
                <div>
                    ИТОГО:
                </div>
                {(zakaz && zakaz.obshchayaSumma) && <div>
                    {(zakaz.obshchayaSumma).toLocaleString()} руб.
                </div>}
            </div>}
        </div>
    );
}

export default function ZakazPreview(props) {

    const { auth, object, collectionActions } = props;
    const [zakaz, setZakaz] = useState({});
    const [loading, setLoading] = useState(false);

    const { setCollectionItem } = collectionActions;

    // const ekvairingRevoke = React.useMemo(() => (ekvairingID) => {
    //     Modal.confirm({
    //         title: 'Отменить заказ?',
    //         icon: <ExclamationCircleOutlined />,
    //         // content: '',
    //         okText: "Да",
    //         cancelText: "Нет",
    //         onOk: () => {
    //             setLoading(true);
    //             GET(auth, `/ekvairing/pay-keeper/revoke/${ekvairingID}`,
    //                 ({ data }) => {
    //                     let o = { ...zakaz, ekvairingZakaz: (data) ? [data] : undefined }
    //                     setCollectionItem(o);
    //                     // update();
    //                     setLoading(false);
    //                 }, (err) => errorCatch(err, () => setLoading(false)));
    //         },
    //     });
    // }, [zakaz, collectionActions]);

    const ekvairingCheckstatusnotpaidekvairing = React.useMemo(() => (zakazID) => {
        setLoading(true);
        GET(auth, `/ekvairing/checkstatusnotpaidekvairing/${zakazID}`,
            ({ data }) => {
                let o = { ...zakaz, ...data.zakaz, ekvairingZakaz: (data) ? [data] : undefined }
                setCollectionItem(o);
                // update();
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
    }, [zakaz, collectionActions]);

    const vozvrat = React.useMemo(() => (zakazID) => {
        setLoading(true);
        GET(auth, `/api/zakaz/summa-vozvrata/${zakazID}`,
            ({ data }) => {

                Modal.confirm({
                    title: 'Выполнить возврат средств?',
                    icon: <ExclamationCircleOutlined />,
                    content: `Сумма в размере ${Number(data.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб. будет возвращена клиенту.`,
                    okText: "Да",
                    cancelText: "Нет",
                    onOk: () => {
                        setLoading(true);
                        GET(auth, `/api/zakaz/vozvrat/${zakazID}`,
                            ({ zakaz }) => {
                                setCollectionItem(zakaz);
                                // update();
                                setLoading(false);
                            }, (err) => errorCatch(err, () => setLoading(false)));
                    },
                });

                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
    }, [zakaz, collectionActions]);

    useEffect(() => {
        if (object) {
            setLoading(true);
            GET(auth, `/api/zakaz/bynumber/${object.nomerZakaza}`, ({ data }) => {
                if (data) {
                    setZakaz(data);
                }
                setLoading(false);
            }, (err) => errorCatch(err, setLoading(false)))
        }
    }, [object]);

    const pay = (path) => {
        window.location.href = path
    };
    const buttons = (item) => {
        if (item) {
            let jsx = []
            if (item.statusID == 3) {
                jsx.push(<Button key="42" onClick={() => {
                    Modal.confirm({
                        title: 'Отправка заказа на почту',
                        icon: <ExclamationCircleOutlined />,
                        content: 'Отправить письмо с заказом на Ваш адрес электронной почты?',
                        okText: "Да",
                        cancelText: "Нет",
                        onOk() {
                            setLoading(true);
                            GET(auth, `/api/zakaz/send-email/${object.ID}`, () => {
                                setLoading(false);
                            }, (err) => errorCatch(err, setLoading(false)))
                        },

                        onCancel() {

                        },
                    });

                }}>Отправить на почту</Button>)
            }
            if (item.obshchayaSumma > 0 && item.statusID == 3 && dayjs().isBefore(dayjs(item.meropriyatie.nachaloSorevnovaniya))) {
                jsx.push(
                    <div key="1" style={{ display: "flex", justifyContent: "end", gap: "5px", paddingBottom: "5px" }}>
                        <Button key="4" onClick={() => vozvrat(item.ID)}>Возврат</Button>
                    </div>
                )
            }

            if (item.ekvairingZakaz && item.ekvairingZakaz[0]) {
                let paymentStateID = item.ekvairingZakaz[0].paymentStateID;
                if (paymentStateID == 2) {
                    jsx.push(<Button key="0" onClick={() => ekvairingCheckstatusnotpaidekvairing(item.ID)}>Обновить статус</Button>)
                    jsx.push(<div key="1" style={{ display: "flex", justifyContent: "end", gap: "5px", paddingBottom: "5px" }}>
                        <Button key="2" onClick={() => pay(item.ekvairingZakaz[0].paymentUrl)}>Оплатить заказ</Button>
                        {/* <Button key="3" onClick={() => ekvairingRevoke(item.ekvairingZakaz[0].ID)}>Отменить заказ</Button> */}
                    </div>)

                } else if (paymentStateID == 3 && item.statusID == 1) {
                    jsx.push(
                        <Button key="0" onClick={() => ekvairingCheckstatusnotpaidekvairing(item.ID)}>Обновить статус</Button>,
                    )
                }
            }
            return jsx;
        }
        return (<></>);
    };

    return (<>
        {object?.promokod && <div>
            <div style={{ fontSize: "12px" }}>Промокод: <span style={{ fontWeight: "bold" }}>{object?.promokod}</span></div>
        </div>}
        {/* {(object.ekvairingZakaz && object.ekvairingZakaz[0]) && <div>
            Оплата заказа №{object.ekvairingZakaz[0].nomer}
        </div>} */}
        <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "5px", paddingTop: "15px" }}>
            {buttons(object)}
        </div>
        {If(!!zakaz, <CollectionList auth={auth} zakaz={zakaz} promo={zakaz.promokod} loading={loading} />)}
    </>);
}
// PaymentForm.whyDidYouRender = true
// CollectionList.whyDidYouRender = true
